import Monetary from 'components/UI/Data/Monetary';
import * as BuyIntentionModels from 'model/BuyIntention';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

interface Props {
  item: BuyIntentionModels.BuyIntentionData;
  currentStep: number;
  total: number;
  onOpen: (item: BuyIntentionModels.BuyIntentionData) => void;
}

export default function BuyIntentionItemCard({
  item,
  currentStep,
  total,
  onOpen,
}: Props) {
  const { t } = useTranslation();
  const producer = item.site
    ? `${item.site.account} - ${item.site.tradingName}`
    : undefined;
  const hasQuantities = Boolean(item.quantityPacking && item.quantityUnit);

  return (
    <li>
      <S.CardButton type="button" onClick={() => onOpen(item)}>
        <S.CardHeader>
          <S.CardTitle>{item.productName}</S.CardTitle>
          {total > 0 && (
            <S.CardTotal>
              <Monetary symbol value={total} />
            </S.CardTotal>
          )}
        </S.CardHeader>
        {item.site?.conceptName && (
          <S.CardConcept>{item.site.conceptName}</S.CardConcept>
        )}
        <S.CardSecondary>
          {[item.productCode, producer].filter(Boolean).join(' · ')}
        </S.CardSecondary>
        {(item.qualitySelect || item.packingSelected || hasQuantities) && (
          <S.CardDetails>
            {item.qualitySelect && (
              <span>
                {t('buyIntention.table.quality')} {item.qualitySelect}
              </span>
            )}
            {item.packingSelected && (
              <span>
                {item.packingSelected.code} - {item.packingSelected.abbrev}
              </span>
            )}
            {hasQuantities && (
              <span>
                {item.quantityPacking} × {item.quantityUnit}
              </span>
            )}
          </S.CardDetails>
        )}
        {item.observationText && (
          <S.CardObservation>{`Obs.: ${item.observationText}`}</S.CardObservation>
        )}
        {item.bought && <S.CardTag>{t('buyIntention.table.bought')}</S.CardTag>}
        {item.intention && currentStep === 0 && (
          <S.CardTag>{t('buyIntention.table.intention')}</S.CardTag>
        )}
      </S.CardButton>
    </li>
  );
}
